import { RegisterOptions } from 'react-hook-form';

export const phoneNumberMinLength = ( message: string, phoneLength: number ): RegisterOptions['minLength'] => {
  return {
    value: phoneLength,
    message,
  };
};
